import { HttpErrorResponse } from '@angular/common/http';
import { ApiError } from '../../core/models/api-error.model';
import { ApiResponse } from '../../core/models/api-response.model';
import { MENSAGENS_PADRAO } from '../constants/mensagens.const';

export class ApiErrorUtil {
  static extrairMensagens(errors?: ApiError[] | null): string[] {
    if (!errors || errors.length === 0) {
      return [];
    }

    return errors
      .map((erro) => this.formatarErro(erro))
      .filter((mensagem) => mensagem.trim().length > 0);
  }

  static extrairDoResponse<T>(response?: ApiResponse<T> | null): string[] {
    return this.extrairMensagens(response?.errors ?? []);
  }

  static extrairDoHttpError(error: unknown): string[] {
    if (error instanceof HttpErrorResponse) {
      if (error.error instanceof Blob) {
        return [];
      }

      const payload = error.error as ApiResponse<unknown> | undefined;

      if (payload?.errors?.length) {
        return this.extrairMensagens(payload.errors);
      }

      if (typeof error.error === 'string' && error.error.trim().length > 0) {
        return [error.error];
      }
    }

    if (error && typeof error === 'object' && 'message' in error) {
      const mensagem = String((error as { message?: string }).message ?? '');
      if (mensagem.trim().length > 0) {
        return [mensagem];
      }
    }

    return [];
  }

  static formatarErro(error: ApiError): string {
    const mensagem = String(error.message ?? '').trim();
    const campo = String(error.field ?? '').trim();

    if (!campo) {
      return mensagem || MENSAGENS_PADRAO.OPERACAO_INDISPONIVEL;
    }

    const labelCampo = this.humanizarCampo(campo);

    if (!mensagem) {
      return `${labelCampo}: ${MENSAGENS_PADRAO.CAMPO_OBRIGATORIO.toLowerCase()}`;
    }

    return `${labelCampo}: ${mensagem}`;
  }

  static humanizarCampo(campo: string): string {
    const texto = campo
      .replace(/\[\d+\]/g, '')
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .replace(/_/g, ' ')
      .replace(/\./g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

    return texto.charAt(0).toUpperCase() + texto.slice(1);
  }

  static extrairErrosDeCampo(errors?: ApiError[] | null): ApiError[] {
    if (!errors || errors.length === 0) {
      return [];
    }

    return errors.filter((erro) => String(erro.field ?? '').trim().length > 0);
  }

  static extrairErrosGerais(errors?: ApiError[] | null): ApiError[] {
    if (!errors || errors.length === 0) {
      return [];
    }

    return errors.filter((erro) => String(erro.field ?? '').trim().length === 0);
  }
}
